'use strict';

const { h, Component } = require('phy');
const { Translate } = require('@grpn/preact-l10n');

const RichText = require('../../shared/views/rich-text');
const LeaderboardBannerWrapper = require('../../../components/leaderboard_banner');
const EmailSubscription = require('../../email_subscription/views/email-subscription');
const { pruneData } = require('../../support/prune-data');
const CouponsGridRow = require('./coupons-grid-row');

const customContentPosition = 8;
const defaultRowType = 'DEFAULT_ROW';
const customRowType = 'CUSTOM_ROW';
const customBreakoutType = 'CUSTOM_BREAKOUT';

function getMedia(coupon) {
  const { media: advertMedia, offerMedia, merchant } = coupon;

  const mediaResult = [];

  if (Array.isArray(advertMedia) && advertMedia.length) {
    mediaResult.push(...advertMedia);
  }

  if (Array.isArray(offerMedia) && offerMedia.length) {
    mediaResult.push(...offerMedia);
  }

  if (
    merchant &&
    Array.isArray(merchant.merchantMedia) &&
    merchant.merchantMedia.length
  ) {
    mediaResult.push(...merchant.merchantMedia);
  }

  return mediaResult;
}

function getItems({ coupons, leaderboardBanner, richText, emailSubscription }) {
  const couponsFormatted = coupons.map(coupon => ({
    id: coupon.offerId,
    offerId: coupon.offerId,
    offerType: coupon.offerType,
    media: getMedia(coupon),
    advertName: coupon.advertName,
    description: coupon.description,
    offerTitle: coupon.offerTitle,
    isExclusive: coupon.isExclusive,
    merchantName:
      coupon.merchantName || (coupon.merchant && coupon.merchant.merchantName),
    offerCallout: coupon.offerCallout || coupon.calloutValue,
    expiryDateTime: coupon.expiryDate || coupon.expiryDateTime,
    offerExpiry: coupon.offerExpiry,
  }));

  return [
    {
      type: defaultRowType,
      children: [...couponsFormatted.slice(0, customContentPosition)],
    },
    {
      type: customRowType,
      children: leaderboardBanner,
    },
    {
      type: customBreakoutType,
      children: richText,
    },
    {
      type: customRowType,
      children: emailSubscription,
    },
    {
      type: defaultRowType,
      children: [...couponsFormatted.slice(customContentPosition)],
    },
  ];
}

class CouponsGrid extends Component {
  constructor(props) {
    super(props);
    this.state = {
      innerWidth: 0,
    };
    this.windowResize = this.windowResize.bind(this);
  }

  componentDidMount() {
    this.setState({
      innerWidth: window.innerWidth,
    });
    window.addEventListener('resize', this.windowResize);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.windowResize);
  }

  windowResize() {
    this.setState({
      innerWidth: window.windowInnerWidth,
    });
  }

  render() {
    const {
      coupons,
      routes,
      isTouch,
      leaderboardAdverts,
      showSeoContent,
      csrfToken,
    } = this.props;
    const { innerWidth } = this.state;

    const leaderboardBanner = LeaderboardBannerWrapper({
      adverts: leaderboardAdverts,
      isTouch,
      routes: pruneData(routes, 'merchant:show'),
    });

    const richText = RichText({
      display: showSeoContent,
      sectionHeadingKey: 'js.modules.home.PrimarySeoHeading',
      richTextKey: 'js.modules.home.PrimarySeoText',
      hasContrast: true,
    });

    const emailSubscription = EmailSubscription({
      csrfToken,
      routes,
      classNames: {
        inner: !isTouch && 'email-subscription-full-width',
      },
      bhwName: 'EmailSubscription',
    });

    if (!Array.isArray(coupons) || !coupons.length) {
      return h('', [
        h('.page-container', h('.row', h('.twelve.column', leaderboardBanner))),
        richText,
        h('.page-container', h('.row', h('.twelve.column', emailSubscription))),
      ]);
    }

    const items = getItems({
      coupons,
      leaderboardBanner,
      richText,
      emailSubscription,
    });

    return h(
      '.coupons-grid',
      {
        'data-bhw': 'coupons-grid',
      },
      [
        h(
          '.page-container',
          h(
            '.row',
            h(
              Translate,
              { tag: 'h2', attrs: { class: 'secondary-title twelve column' } },
              'js.modules.home.TopOffersHeadingFormat'
            )
          )
        ),
        items.map(item =>
          CouponsGridRow({
            item,
            routes,
            innerWidth,
            isTouch,
            customBreakoutType,
            customRowType,
          })
        ),
      ]
    );
  }
}

module.exports = CouponsGrid;
